import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ethers } from "ethers";

import {
  ButtonContainer2,
  DetailCard,
  DetailsContainer,
  FilledButton,
  InputContainer,
  OutlinedButton,
  Prop,
  Value,
} from "./style";
import FormCard from "../../../reusables/cards/FormCard";
import StepperComponent from "../../../reusables/Steppers";
import {
  fillCreatePoolForm,
  saveRewardPoolTxApi,
} from "../../../../redux/actions/poolAction";
import web3 from "web3";
import ErrorMessage from "../../../reusables/MessagePopups/ErrorMessage";
import {
  createScheduledRewardPool,
  createScheduledRewardPoolNative,
} from "../../../../methods/contracts/scheduledRewardPool";

const ScheduledFormThree = ({ activeStep, steps, setActiveStep }) => {
  const poolInfo = useSelector((state) => state.PoolReducer);
  const user = useSelector((state) => state.persistedStore);
  const dispatch = useDispatch();
  const [errors, setErrors] = useState();

  const mapAddressesToRewards = (addresses, amounts) => {
    if (addresses.length !== amounts.length) {
      throw new Error(
        "Addresses and amounts arrays must be of the same length"
      );
    }

    return addresses.map((address, index) => ({
      eligibleAddress: address,
      rewardAmount: amounts[index],
    }));
  };

  const handleConfirm = async (e) => {
    const Web3 = new web3(window.ethereum);
    try {
      e.preventDefault();
      // Convert recipient amounts to Wei
      const recipientAmountsInWei = poolInfo?.recipientAmounts.map((amount) =>
        Web3.utils.toWei(amount.toString(), "ether")
      );
      const poolIdentifierBytes32 = ethers.encodeBytes32String(
        poolInfo?.poolIdentifier
      );

      // Total amount in Wei
      const totalAmountInWei = recipientAmountsInWei.reduce(
        (acc, curr) => acc + BigInt(curr) * BigInt(poolInfo?.numberOfDays),
        BigInt(0)
      );
      //  convert time to uint21

      const dateStr = poolInfo?.startTime.replace(/(\d+)(st|nd|rd|th)/, "$1");
      const poolStateDate = new Date(dateStr);
      const timestamp = poolStateDate.getTime() / 1000; // Convert to seconds

      let pool, tx;

      if (poolInfo?.isNativeToken) {
        const result = await createScheduledRewardPoolNative(
          user?.address,
          user?.network,
          poolInfo?.recipientAddresses,
          recipientAmountsInWei,
          poolIdentifierBytes32,
          poolInfo?.poolName,
          timestamp,
          totalAmountInWei,
          poolInfo?.numberOfDays,
          ""
        );
        pool = result.rewardPool;
        tx = result.tx;
      } else {
         console.log(user?.address,
          user?.network,
          poolInfo?.poolToken?.decimal,
          poolInfo?.recipientAddresses,
          recipientAmountsInWei,
          poolIdentifierBytes32,
          poolInfo?.poolName,
          totalAmountInWei,
          poolInfo?.startTime,
          totalAmountInWei,
          poolInfo?.numberOfDays,
          poolInfo.poolToken.tokenAddress, "mark")
        const result = await createScheduledRewardPool(
          user?.address,
          user?.network,
          poolInfo?.poolToken?.decimal,
          poolInfo?.recipientAddresses,
          recipientAmountsInWei,
          poolIdentifierBytes32,
          poolInfo?.poolName,
          timestamp,
          totalAmountInWei,
          poolInfo?.numberOfDays,
          poolInfo.poolToken.tokenAddress
        );
        pool = result.rewardPool;
        tx = result.tx;
      }
      const poolObjectToSave = {
        poolName: poolInfo?.poolName,
        salt: poolInfo?.poolIdentifier,
        creatorAddress: user?.address,
        poolAddress: pool.poolAddress,
        tokenContract: poolInfo?.poolToken?.tokenAddress,
        chainId: user?.networkId.toString(),
        poolType: "SCHEDULED",
        startTime: timestamp,
        numberOfDays: Number(poolInfo?.numberOfDays),
        ipRestrictionEnabled: poolInfo?.ipRestrictionEnabled || false,
        eligibleAddresses: mapAddressesToRewards(
          poolInfo?.recipientAddresses,
          poolInfo?.recipientAmounts
        ),
        blockNumber: Number(tx.blockNumber),
      };

      saveRewardPoolTxApi(poolObjectToSave);
      dispatch(
        fillCreatePoolForm({
          props: ["createdPoolTx"],
          value: tx,
        })
      );
      setActiveStep(3);
    } catch (err) {
      setErrors([err.message]);
    }
  };

  const handlePrevStep = (e) => {
    e.preventDefault();
    setActiveStep(1);
  };

  return (
    <FormCard>
      <StepperComponent activeStep={activeStep} steps={steps} />
      <InputContainer>
        <DetailsContainer>
          <DetailCard>
            <Prop>Pool Name:</Prop>
            <Value>{poolInfo?.poolName}</Value>
          </DetailCard>
          <DetailCard>
            <Prop>Unique Identifier:</Prop>
            <Value>{poolInfo?.poolIdentifier}</Value>
          </DetailCard>
        </DetailsContainer>
        <DetailsContainer>
          <DetailCard>
            <Prop>Description:</Prop>
            <Value>{poolInfo?.poolDescription}</Value>
          </DetailCard>
          <DetailCard>
            <Prop>Start Time:</Prop>
            <Value>{poolInfo?.startTime}</Value>
          </DetailCard>
        </DetailsContainer>
        <DetailsContainer>
          <DetailCard>
            <Prop>Total Addresses:</Prop>
            <Value>{poolInfo?.recipientAddresses?.length}</Value>
          </DetailCard>
          <DetailCard>
            <Prop>Amount To Share:</Prop>
            <Value>
              {Array.isArray(poolInfo?.recipientAmounts)
                ? poolInfo.recipientAmounts.reduce(
                    (acc, curr) => acc + Number(curr * poolInfo?.numberOfDays),
                    0
                  )
                : 0}
              {poolInfo?.isNativeToken
                ? user?.network?.nativeCurrency?.symbol
                : poolInfo?.poolToken?.symbol}
            </Value>
          </DetailCard>
        </DetailsContainer>
        <DetailsContainer>
          <DetailCard>
            <Prop>Balance:</Prop>
            <Value>
              {poolInfo?.isNativeToken
                ? poolInfo?.walletBalance
                : poolInfo?.poolToken?.balance}{" "}
              {poolInfo?.isNativeToken
                ? user?.network?.nativeCurrency?.symbol
                : poolInfo?.poolToken?.symbol}
            </Value>
          </DetailCard>
          <DetailCard>
            <Prop>Number of Days:</Prop>
            <Value>{poolInfo?.numberOfDays}</Value>
          </DetailCard>
        </DetailsContainer>
        <DetailsContainer>
          <DetailCard>
            <Prop>Pool Type:</Prop>
            <Value>{poolInfo?.poolType}</Value>
          </DetailCard>
        </DetailsContainer>
        {errors?.length > 0 && (
          <ErrorMessage
            message={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  color: "red",
                }}
              >
                {errors?.map((error) => (
                  <span key={error}>{error}</span>
                ))}
              </div>
            }
          />
        )}
      </InputContainer>
      <ButtonContainer2>
        <OutlinedButton onClick={handlePrevStep}>Back</OutlinedButton>
        {/* <FilledButton onClick={handleConfirm}>Confirm</FilledButton> */}
        <FilledButton
          onClick={handleConfirm}
          disabled={poolInfo?.isCreatingPool}
        >
          {poolInfo?.isCreatingPool ? (
            ' Creating Pool...'
           
          ) : (
            "Confirm"
          )}
        </FilledButton>
      </ButtonContainer2>
    </FormCard>
  );
};

export default ScheduledFormThree;
